<template>
  <v-card>
    <v-card-text>
      <v-select
        label="Разделитель"
        :items="delimiters"
        style="max-width: 20% !important"
        dense
        class="ml-8"
        v-model="del1"
        @change="selectChanged"
      />
      <v-file-input
        label="Древо"
        dense
        style="max-width: 50% !important"
        @change="file1Change"
      />
      <v-divider class="mb-5" />
      <v-select
        label="Разделитель"
        :items="delimiters"
        style="max-width: 20% !important"
        dense
        class="ml-8"
        v-model="del2"
        @change="selectChanged"
      />
      <v-file-input
        label="Декомплектация"
        dense
        style="max-width: 50% !important"
        @change="file2Change"
      />
    </v-card-text>
    <v-card-actions>
      <v-btn
        block
        class="primary"
        @click="parse"
        :disabled="!filesOk || parsed"
      >
        Распарсить файлы
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["parseFiles", "clearParsed"]),
    async parse() {
      this.$emit("loading-start", "Парсинг файлов");
      let success = await this.parseFiles({
        file1: this.file1,
        file2: this.file2,
        del1: this.del1,
        del2: this.del2,
      });
      if (success) {
        this.$emit("cant-continue", false);
        this.parsed = true;
      }
      this.$emit("loading-stop");
    },
    file1Change(file) {
      this.$emit("cant-continue", true);
      this.file1 = file;
      this.parsed = false;
    },
    file2Change(file) {
      this.$emit("cant-continue", true);
      this.file2 = file;
      this.parsed = false;
    },
    selectChanged() {
      this.$emit("cant-continue", true);
      this.parsed = false;
    },
  },
  data: () => ({
    file1: null,
    file2: null,
    del1: null,
    del2: null,
    delimiters: [
      { text: ".", value: "." },
      { text: ",", value: "," },
      { text: ";", value: ";" },
      { text: "Автовыбор", value: null },
    ],
    parsed: false,
  }),
  computed: {
    filesOk() {
      return this.file1 != null && this.file2 != null;
    },
  },
  watch: {
    filesOk() {
      this.$emit("cant-continue", true);
      this.parsed = false;
    },
  },
  mounted() {
    this.clearParsed();
    this.$emit("cant-continue", true);
  },
};
</script>